import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { mvs } from 'react-native-size-matters';

import { COLORS } from '../../constants';
import { usePlaybackSpeed } from '../../hooks/usePlaybackSpeed';
import CustomText from '../CustomText';

interface PlaybackSpeedProps {
  textColorStyle?: string;
  textSize?: number;
}

export const PlaybackSpeed: React.FC<PlaybackSpeedProps> = ({
  textColorStyle = COLORS.WHITE,
  textSize = 20,
}) => {
  const { playerRate, handleSpeedChange } = usePlaybackSpeed();

  return (
    <TouchableOpacity
      style={[
        styles.container,
        {
          width: mvs(textSize * 2.7), // Fixed width to avoid layout shift + multiplyer for Roboto Mono widest font
        },
      ]}
      onPress={handleSpeedChange}
    >
      <CustomText
        style={[
          {
            color: textColorStyle,
            fontSize: mvs(textSize),
            lineHeight: mvs(textSize + 2),
          },
        ]}
        weight="Bold"
      >
        x{playerRate}
      </CustomText>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
});
